import api from '../../api';
import eventBus from '../../messaging/event-bus';
import { AccountServiceEnabled, AccountServiceDisabled } from '../../messaging/events';
import { AccountService } from '../../types';

export function enable(accountId: string, serviceId: string): Promise<AccountService> {
  return api
    .post(`accounts/${accountId}/services`, { serviceId })
    .then((response) => {
      const accountService: AccountService = response.data as AccountService;
      eventBus.$emit(AccountServiceEnabled.eventName, new AccountServiceEnabled(accountService));
      return accountService;
    });
}

export function disable(accountServiceId: string): Promise<void> {
  return api
    .delete(`account-services/${accountServiceId}`)
    .then(() => {
      eventBus.$emit(
        AccountServiceDisabled.eventName,
        new AccountServiceDisabled(accountServiceId),
      );
    });
}
